import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from './interfaces'

import { useDisciplineStore } from '@stores/discipline'

import { report } from '@utils/stores/progress-report/getters/report'
import { period } from '@utils/stores/progress-report/getters/period'
import { tutor } from '@utils/stores/progress-report/getters/tutor'
import { message } from '@utils/stores/progress-report/getters/message'
import { stats } from '@utils/stores/progress-report/getters/stats'
import { lessons } from '@utils/stores/progress-report/getters/lessons'
import { achievements } from '@utils/stores/progress-report/getters/achievements'
import { schedule } from '@utils/stores/progress-report/getters/schedule'

export const getters = {
  isLoading: (state: ProgressReportStore): ProgressReportStore['reportLoading' | 'reportsLoading'] => state.reportLoading || state.reportsLoading,
  isReportLoading: (state: ProgressReportStore): ProgressReportStore['reportLoading'] => state.reportLoading,
  isReportsLoading: (state: ProgressReportStore): ProgressReportStore['reportsLoading'] => state.reportsLoading,
  getReports: (state: ProgressReportStore): ProgressReport[] | null => {
    const disciplineStore = useDisciplineStore()

    return disciplineStore.isEla
      ? state.reportsEla
      : disciplineStore.isMath
        ? state.reportsMath
        : null
  },
  isNewProgressReport: (state: ProgressReportStore): boolean => {
    const disciplineStore = useDisciplineStore()

    return disciplineStore.isEla
      ? state.newProgressReportEla
      : disciplineStore.isMath
        ? state.newProgressReportMath
        : false
  },
  ...report,
  ...period,
  ...tutor,
  ...message,
  ...stats,
  ...lessons,
  ...achievements,
  ...schedule,
}
